import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { AppleIdConfig } from 'interfaces/pns-phone-number'

interface UseAppleIdConfigsParams {
  limit?: number
  offset?: number
  unassigned?: boolean // Filter for Apple IDs not assigned to any infrastructure
}

interface AppleIdConfigResponse {
  data: AppleIdConfig[]
  meta: {
    total: number
    limit: number
    offset: number
    count: number
  }
}

const fetchAppleIdConfigs = async (params?: UseAppleIdConfigsParams) => {
  const queryParams = new URLSearchParams()

  if (params?.limit) queryParams.append('limit', params.limit.toString())
  if (params?.offset) queryParams.append('offset', params.offset.toString())
  if (params?.unassigned !== undefined) {
    queryParams.append('unassigned', params.unassigned.toString())
  }

  const url = `${BASE_API_URL}/api/v4/phone_number_service/apple_id_configs?${queryParams.toString()}`

  let response = await fetch(url, {
    method: API_METHODS.GET,
    headers: apiHeaders(store.getState()),
  })
  response = handleErrors(response)
  return response.json()
}

const useAppleIdConfigs = (params?: UseAppleIdConfigsParams) => {
  return useQuery<AppleIdConfigResponse>(['apple-id-configs', params], () =>
    fetchAppleIdConfigs(params)
  )
}

export default useAppleIdConfigs
